import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  googleButton: {
    background: 'white',
    color: 'rgb(0, 94, 166)',
    borderRadius: '4px',
    border: '2px solid rgb(2, 122, 197)',
    margin: '1.8em 0 0.7em',
    textTransform: 'none',
    boxShadow: 'none',
    padding: '0.3em 1em',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:hover': {
      background: 'white',
      boxShadow: 'none',
    },
  },
  errorMessage: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    margin: '1em 0 0.2em',
    '& svg': {
      marginRight: '0.4em',
    },
  },
  gutterBottom: {
    marginBottom: '1em',
  },
  passcodeContainer: {
    minHeight: '120px',
  },
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  fileButtonLoadingSpinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '40px',
  },
}));
const text =
  'Looks like you have cancelled your session with My Emergency Doctor. To join a video conference please relaunch the Katherine Hospital link';

export default function CallEndedScreen() {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h6" className={classes.gutterBottom}>
        {text}
      </Typography>
      <form>
        <Grid container justifyContent="space-between">
          <Grid container justifyContent="flex-end"></Grid>
        </Grid>
        <Grid container justifyContent="flex-end">
          Thankyou for using My Emergency Dr.
        </Grid>
      </form>
    </>
  );
}
